module.exports = __webpack_public_path__ + "img/ic_search.049a12a6.svg";